import {NetworkCodeList} from '../../types/interfaces/configuration';


export class FetchNetworkCode {
  static readonly type = '[networkCode] Fetch All';

  constructor(public payload: NetworkCodeList[]) {
  }
}
